'use client';

import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React from 'react';
import Typography from '@ui/Typography';

const tabs = [
  { name: 'About', search: 'about' },
  { name: 'Activities', search: 'activities' },
];

function MobileViewSelector(props) {
  const { view, detailView } = props;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const selected = searchParams.get('view');
  const selectedIndex = tabs.findIndex((tab) => tab.search === selected);

  const onTabChange = (index) => {
    const params = new URLSearchParams(searchParams);
    params.delete('webView');


    if (index === 0 && detailView !== 'overview') {
      params.set('detailView', 'overview'); // TODO: check
      router.push(pathname + '?' + params.toString(), {
        scroll: false,
      });
    }

    params.set('view', tabs[index].search);
    router.push(pathname + '?' + params.toString(), {
      scroll: false,
    });
  };

  return (
    <Tab.Group
      defaultIndex={selectedIndex === -1 ? 0 : selectedIndex}
      onChange={onTabChange}>
      <Tab.List className="flex w-full justify-start">
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            className={({ selected }) =>
              clsx(
                'text-h4 flex-1 px-6 py-2 text-text-primary outline-none',
                selected ? 'bg-white' : 'bg-transparent',
              )
            }>
            <Typography
              variant="h3"
              className={`${
                view === tab.search ? 'text-text-primary' : 'text-[#00000033]'
              }`}>
              {tab.name}
            </Typography>
          </Tab>
        ))}
      </Tab.List>
    </Tab.Group>
  );
}

export default MobileViewSelector;
